export const AFTERSALES_WORKFLOW_STATUS = [
    'INITIATED',
    'SERVICE',
    'OVERDUE'
]